import React, { useEffect, useState } from 'react'
import { ColorToHex, renderAsText, renderAsHtml } from '../../utility'
import * as styles from './index.module.css'
import { Modal } from 'react-bootstrap'

const ImageModal = (props) => {
  const [show, setShow] = useState(false);
  const [isScreenSmall, setIsScreenSmall] = useState(false);
  const { image } = props;

  console.log(image);

  const getScreenWidth = () => {
    setIsScreenSmall(window.innerWidth < 768);
  };

  useEffect(() => {
    getScreenWidth();

    window.addEventListener('resize', getScreenWidth);

    return () => window.removeEventListener('resize', getScreenWidth);
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    if (!isScreenSmall) {
      setShow(true);
    }
  };

  return (
    <React.Fragment>
      {image && (
        <div className={styles.imageModalContainer} onClick={handleShow}>
          <img
            src={image.url}
            alt={image.alt}
          />
        </div>
      )}

      {/* Modal */}
      {image && (
        <Modal show={show} onHide={handleClose} dialogClassName={styles.imageModalDialog}>
          <Modal.Header
            className={styles.imageModalHeader}
            closeButton
          >
            <div className={styles.imageWrapper}>
              <img
                src={image.url}
                alt={image.alt}
              />
            </div>
          </Modal.Header>
        </Modal>
      )}
    </React.Fragment>
  )
}

export default ImageModal;
